export default "__VITE_ASSET__fr_kvees__"